import { render, staticRenderFns } from "./ClientTestimonials.vue?vue&type=template&id=452e186c&scoped=true&"
import script from "./ClientTestimonials.vue?vue&type=script&lang=js&"
export * from "./ClientTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./ClientTestimonials.vue?vue&type=style&index=0&id=452e186c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e186c",
  null
  
)

export default component.exports